<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">

            <!-- 序号 -->
            <el-table-column align="left" label="序号" >
            <template slot-scope="scope">
                <span>{{scope.row.serial_number}}</span>
            </template>
            </el-table-column>

            <!-- 业务线 -->
            <el-table-column align="left" label="业务线" >
            <template slot-scope="scope">
                <span>{{scope.row.business_line}}</span>
            </template>
            </el-table-column>

            <!-- 保单号 -->
            <el-table-column align="left" label="保单号" >
            <template slot-scope="scope">
                <span>{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 保险起期 -->
            <el-table-column align="left" label="保险起期" >
              <template slot-scope="scope">
                <span>{{ scope.row.effective_date | parseTime('{y}年{m}月{d}日') }}</span>
              </template>
            </el-table-column>

            <!-- 险种 -->
            <el-table-column align="left" label="险种" >
            <template slot-scope="scope">
                <span>{{ scope.row.insruance_type }}</span>
            </template>
            </el-table-column>

            <!-- 渠道编码 -->
            <el-table-column align="left" label="渠道编码" >
            <template slot-scope="scope">
                <span>{{ scope.row.channel_code }}</span>
            </template>
            </el-table-column>

            <!-- 付费日期 -->
            <el-table-column align="left" label="付费日期" >
              <template slot-scope="scope">
                <span>{{ scope.row.payment_date | parseTime('{y}年{m}月{d}日') }}</span>
              </template>
            </el-table-column>

            <!-- 转应收应付日期 -->
            <el-table-column align="left" label="转应收应付日期" >
              <template slot-scope="scope">
                <span>{{ scope.row.receivable_and_payable_date | parseTime('{y}年{m}月{d}日') }}</span>
              </template>
            </el-table-column>

            <!-- 业务员 -->
            <el-table-column align="left" label="业务员" >
            <template slot-scope="scope">
                <span>{{ scope.row.salesman}}</span>
            </template>
            </el-table-column>

            <!-- 被保人名称 -->
            <el-table-column align="left" label="被保人名称" >
            <template slot-scope="scope">
                <span>{{ scope.row.insured}}</span>
            </template>
            </el-table-column>

            <!-- 核保时间 -->
            <el-table-column align="left" label="核保时间" >
              <template slot-scope="scope">
                <span>{{ scope.row.underwriting_date | parseTime('{y}年{m}月{d}日') }}</span>
              </template>
            </el-table-column>

            <!-- 单面保费 -->
            <el-table-column align="left" label="单面保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 不含税保费 -->
            <el-table-column align="left" label="不含税保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.tax_free_premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 手续费比率 -->
            <el-table-column align="left" label="手续费率" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate}}</span>
            </template>
            </el-table-column>

            <!-- 手续费金额-->
            <el-table-column align="left" label="手续费金额" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 船名-->
            <el-table-column align="left" label="船名" >
            <template slot-scope="scope">
                <span>{{ scope.row.ship_name}}</span>
            </template>
            </el-table-column>

        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-zi-jin',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
